import { useMutation } from 'react-query'
import request from '../../../request'
import { useSelector } from 'react-redux'
import { selectedDealership } from '../../../../store/selectors/dealershipSelector'
import { useDealership } from '../../../../store/zustand/dealershipStore'

export const useAiQueryGenerator = () => {
  const dealership = useDealership()
  return useMutation(
    ({
      audience_description,
      audience_id,
    }: {
      audience_description: any
      audience_id: string
    }) =>
      request<{ data: { count: number; query: Record<string, any> } }>({
        method: 'POST',
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/customers/audiences/${audience_id}/query-generator`,
        data: {
          audience_description,
        },
      }),
  )
}
